import {all, fork} from 'redux-saga/effects';
import {getClaimsSaga} from './get-claims.saga';

export function* claimSaga() {
    yield all([fork(getClaimsSaga)]);
}
